import { Step } from 'shared/InstallationDialog';
import { spawn } from 'utils/translations';
import {
  GERRIT_LABEL_PERMISSIONS,
  GERRIT_REF_PERMISSIONS,
  PREREQUISITES_TRANSLATION_KEY,
} from '../consts';
import { PermissionsTable } from '../parts/PermissionsTable';

const spawnPrereq = spawn(PREREQUISITES_TRANSLATION_KEY);

/**
 * View 0 — informational prerequisites. Tells the operator to create a
 * dedicated Qodo user in their Gerrit server and grant it the permissions
 * below before entering its credentials on the next step. No inputs; the footer
 * Continue simply advances the wizard.
 */
export const Prerequisites = () => (
  <Step title={spawnPrereq('title')} description={spawnPrereq('description')}>
    <PermissionsTable
      title={spawnPrereq('ref-permissions.title')}
      headers={[
        spawnPrereq('ref-permissions.columns.ref-pattern'),
        spawnPrereq('ref-permissions.columns.purpose'),
      ]}
    >
      {GERRIT_REF_PERMISSIONS.map((permission) => (
        <tr key={permission.pattern}>
          <td className="border border-border-bg-neutral px-3 py-2 align-top">
            <code className="text-text-general-neutral-strong">
              {permission.pattern}
            </code>
          </td>
          <td className="border border-border-bg-neutral px-3 py-2 align-top text-text-general-neutral-mild">
            {spawnPrereq(permission.purposeKey)}
          </td>
        </tr>
      ))}
    </PermissionsTable>

    <PermissionsTable
      title={spawnPrereq('label-permissions.title')}
      headers={[
        spawnPrereq('label-permissions.columns.label'),
        spawnPrereq('label-permissions.columns.range'),
        spawnPrereq('label-permissions.columns.purpose'),
      ]}
    >
      {GERRIT_LABEL_PERMISSIONS.map((permission) => (
        <tr key={permission.label}>
          <td className="border border-border-bg-neutral px-3 py-2 align-top">
            <code className="text-text-general-neutral-strong">
              {permission.label}
            </code>
          </td>
          <td className="border border-border-bg-neutral px-3 py-2 align-top">
            <code className="text-text-general-neutral-strong">
              {permission.range}
            </code>
          </td>
          <td className="border border-border-bg-neutral px-3 py-2 align-top text-text-general-neutral-mild">
            {spawnPrereq(permission.purposeKey)}
          </td>
        </tr>
      ))}
    </PermissionsTable>
  </Step>
);
